import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep2Form from '../../components/VoteRegistration/VoteRegistrationStep2Form';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';

import { CardTypes, AddressSource, StatesId } from '../../utils/enums';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep2 = props => (
    <TransitionContainer isSubmitting={props.isAddressSubmitting} zIndex={22}>
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep2Form
                    onBack={() => {
                        props.onGoToStep(1, 'back');
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.saveForm(
                            values,
                            [],
                            props.apiRequestData,
                            props.formData,
                            props.id,
                            props.answerId,
                            AddressSource.userInput,
                            false,
                            props.actionIdentifier,
                            props.isMultiActionsCard
                        );
                    }}
                    isAddressSubmitting={props.isAddressSubmitting}
                    states={props.states}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep2.propTypes = {
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    id: PropTypes.number,
    answerId: PropTypes.number,
    formData: PropTypes.object,
    isAddressSubmitting: PropTypes.bool,
    states: PropTypes.array,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => ({
        apiRequestData: state.widget.apiRequestData,
        id: state.widget.activeAction.id,
        answerId:
            state.voteRegistration.completeVoteRegistration.voteRegistrationAnswerId,
        formData: state.voteRegistration.formData,
        isAddressSubmitting: state.voteRegistration.isAddressSubmitting,
        states: StatesId,
        isBackTransition: state.voteRegistration.isBackTransition,
        isMobileResolution: state.widget.isMobileResolution,
        actionIdentifier: state.widget.activeAction.identifier,
        isMultiActionsCard:
            state.widget.cards[state.widget.activeAction.order - 1].type ===
            CardTypes.multipleActions
    }),
    {
        onGoToStep,
        saveForm,
        cacheFormData
    }
)(VoteRegistrationStep2);



// WEBPACK FOOTER //
// ./src/containers/VoteRegistration/VoteRegistrationStep2.jsx